<template>
  <div>
    <div class="banner">
      <div class="headerReplacementFinancialInfo"></div>
      <div class="banner-text">
        <b>ข้อมูลสำคัญทางการเงิน</b>
        <div class="breadcrumb">
          <span><router-link to="/" class="pe-auto">หน้าหลักนักลงทุนสัมพันธ์</router-link></span>
          <span class="separator"></span>
          <span>ข้อมูลทางการเงิน</span>
          <span class="separator"></span>
          <span><b>คำอธิบายและการวิเคราะห์ของฝ่ายจัดการ</b></span>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="TabMenu">
        <FinancialInfoTabMenu />
      </div>

      <div class="row justify-content-center align-items-center mb-5">
        <div class="card card-pdf bg-white mt-5 mb-3">
          <div class="row">
            <div class="col-12 col-md-6 text-center bg-black">
              <img src="../../assets/banner/img-2.jpeg" class="img-fluid rounded-start p-3" style="max-height: 300px;">
            </div>
            <div class="col-md-6 d-flex">
              <div class="vertical-line"></div>
              <div class="card-body">
                <p class="card-text text-secondary">คำอธิบายและการวิเคราะห์ของฝ่ายจัดการ</p>
                <h4 class="card-title mb-5"><b>ไตรมาสที่ {{ latestDocument.quarter }} ปี {{ latestDocument.year }}</b>
                </h4>
                <p class="card-text text-secondary">
                  <small class="text-muted">
                      <i class="fa-solid fa-download"></i>
                      <a :href="latestDocument.pdf_url" target="_blank" class="text-decoration-none">
                        ดาวน์โหลด
                      </a>
                    </small>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>


      <div class="row g-3 row justify-content-end mb-3">
        <div class="col-auto">
          <label class="col-form-label">เลือกปี</label>
        </div>
        <div class="col-auto">
          <select id="yearSelect" v-model="selectedYear" class="form-select" aria-label="Year selection">
            <option value="2024">2024</option>
            <option value="2023">2023</option>
            <option value="2022">2022</option>
            <option value="2021">2021</option>
            <option value="2020">2020</option>
            <!-- <option value="2019">2019</option>
            <option value="2018">2018</option>
            <option value="2017">2017</option>
            <option value="2016">2016</option>
            <option value="2015">2015</option>
            <option value="2014">2014</option>
            <option value="2013">2013</option>
            <option value="2012">2012</option>
            <option value="2011">2011</option> -->
          </select>
        </div>
      </div>

      <table class="table mb-5">
        <thead>
          <tr class="table-secondary">
            <th scope="col"><b>{{ selectedYear }}</b></th>
            <th scope="col" class="text-end"><b>เอกสาร</b></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in filteredList" :key="index">
            <td>การวิเคราะห์และคำอธิบายของฝ่ายจัดการไตรมาสที่ {{ item.quarter }}</td>
            <td class="text-end">
              <a :href="item.pdf_url" target="_blank" class="text-decoration-none">
                <p class="card-text text-secondary">
                  <small class="text-muted">
                    <i class="fa-solid fa-download"></i> ดาวน์โหลด
                  </small>
                </p>
              </a>
            </td>
          </tr>
        </tbody>
      </table>
      <div v-if="isLoading" class="d-flex justify-content-center align-items-center mb-5" style="height: 20px;">
        <div class="spinner-grow custom-spinner" role="status"></div>
      </div>
    </div>
  </div>
</template>
  

<script>
import FinancialInfoTabMenu from '@/components/FinancialInfoTabMenu.vue';
import store from "@/store";
import { GET_ANALYSIS_EXPLANATIONL_DATA } from "../../store/actions.type";

export default {
  name: 'Description',
  components: {
    FinancialInfoTabMenu,
  },
  data() {
    return {
      selectedYear: '2024', // เก็บปีที่เลือก
      list: [],  // สถานะสำหรับเก็บข้อมูลทั้งหมดจาก store
      latestDocument: {},  // สถานะสำหรับเก็บเอกสารล่าสุด
      isLoading: false

    };
  },
  async created() {
    this.isLoading = true;
    await this.init();  // เรียกใช้ฟังก์ชัน init เพื่อดึงข้อมูล
    this.isLoading = false;
  },
  computed: {
    // สร้าง computed property สำหรับแสดงรายการที่กรองตามปี
    filteredList() {
      return this.list
        .filter(item => item.year.toString() === this.selectedYear)  // กรองตามปี
        .sort((a, b) => {
          // เรียงลำดับปีจากน้อยไปมาก (จากอดีตไปปัจจุบัน)
          if (a.year === b.year) {
            return a.quarter - b.quarter;  // ถ้าเป็นปีเดียวกันให้เรียงตามไตรมาส
          }
          return a.year - b.year;  // เรียงลำดับปี
        });
    }
  },
  methods: {
    async init() {
      this.list = await store.dispatch(GET_ANALYSIS_EXPLANATIONL_DATA);
      this.latestDocument = this.getLatestDocument();  // เรียกฟังก์ชันเพื่อหาข้อมูลล่าสุด
    },
    // ฟังก์ชันเพื่อดึงเอกสารล่าสุด
    getLatestDocument() {
      return this.list
        .sort((a, b) => {
          if (a.year === b.year) {
            return b.quarter - a.quarter;  // เรียงลำดับจากไตรมาสล่าสุด
          }
          return b.year - a.year;  // เรียงลำดับจากปีล่าสุด
        })[0];  // เลือกรายการแรกสุด (เอกสารล่าสุด)
    }
  },
};
</script>

<style scoped>
.bg-body-docs{
    background-color: #F2F2F2;
}
h2.mt-5 {
    display: inline-block;
    border-bottom: 3px solid #E87D2E;
    padding-bottom: 5px;
}

.card-pdf {
    box-shadow: 0px 4px 10px 0px #0000000D;
    border: none;
    width: 800px;
}

.card {
    background-color: #F2F2F2;
}

.vertical-line {
    width: 4px;
    background-color: #E87D2E;
    height: 160px;
}

th {
    font-weight: normal;
}

.table {
    margin-bottom: 0;
}
</style>
